import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const JOIN_RESUME_KEY = "homiie_join_resume";

// Phones may restart the app while the camera/file picker is open; send unfinished applicants back to their form.
export function JoinResume() {
    const { user } = useAuth();
    const { pathname } = useLocation();
    const nav = useNavigate();
    useEffect(() => {
        if (user?.role === "professional" && localStorage.getItem(JOIN_RESUME_KEY) && ["/", "/pro", "/login"].includes(pathname)) {
            nav("/join-pro", { replace: true });
        }
    }, [user, pathname, nav]);
    return null;
}
